import React from 'react';
import { Button } from 'react-bootstrap';
import { getOrgTermsContent } from '../../content/utils.js';
import AuthorizedAction from '../AuthorizedAction.js';
import MailWhiteIcon from '../icons/MailWhiteIcon.jsx';
import SendFeedbackModal from '../send-feedback-modal/SendFeedbackModal.jsx';
import { ShareIcon } from '../icons/ShareIcon.jsx';

const SurveyReadySendBlock = ({
  initiative,
  title,
  description,
  fullScreen,
  titleSettings = {},
  survey,
  isDateAfter,
  loading,
  isArchivedProject,
  isCanManage,
  initiativeType,
  handleClickSendFeedbackForm,
  handleUpdateEmailSetting,
  handleClickCopyLink,
}) => {
  return (
    <div
      className="component component-bg-white"
      style={
        fullScreen
          ? { height: '100%', paddingTop: '60px' }
          : { paddingTop: '60px' }
      }
    >
      <div
        style={{ display: 'flex', justifyContent: 'center', height: '100%' }}
      >
        <div>
          <h2
            className="m-b-24 text-center"
            style={{ fontSize: '24px', ...titleSettings }}
          >
            {title}
          </h2>
          <p className="m-b-24 text-muted text-center">{description}</p>
          <div className="flex flex-center">
            {isCanManage ? (
              <AuthorizedAction
                action="update"
                subject={`${initiativeType}Initiative`}
              >
                {isArchivedProject || isDateAfter ? (
                  <Button
                    bsStyle="outlined"
                    className="flex m-r-16"
                    onClick={() =>
                      window.alert(
                        isArchivedProject
                          ? getOrgTermsContent('archivedProjectMessage')
                          : 'The feedback form cannot be sent to participants because its dates are in the past. Please update the start and end dates and try again.'
                      )
                    }
                    disabled={loading || !isCanManage}
                  >
                    <ShareIcon />
                    <span className="m-l-4">Copy Sharing link</span>
                  </Button>
                ) : (
                  <Button
                    bsStyle="outlined"
                    className="flex m-r-16"
                    onClick={handleClickCopyLink}
                  >
                    <ShareIcon />
                    <span className="m-l-4">Copy Sharing link</span>
                  </Button>
                )}

                {isArchivedProject || isDateAfter ? (
                  <Button
                    bsStyle="primary"
                    className="flex"
                    onClick={() =>
                      window.alert(
                        isArchivedProject
                          ? getOrgTermsContent('archivedProjectMessage')
                          : 'The feedback form cannot be sent to participants because its dates are in the past. Please update the start and end dates and try again.'
                      )
                    }
                    disabled={loading || !isCanManage}
                  >
                    <MailWhiteIcon />
                    <span className="m-l-4">
                      {loading ? 'Sending' : 'Send Via Email'}
                    </span>
                  </Button>
                ) : (
                  <SendFeedbackModal
                    type="button"
                    survey={survey}
                    loading={loading}
                    isCanManage
                    initiativeType={initiativeType}
                    initiative={initiative}
                    handleClickSendFeedbackForm={handleClickSendFeedbackForm}
                    handleUpdateEmailSetting={handleUpdateEmailSetting}
                  />
                )}
              </AuthorizedAction>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveyReadySendBlock;
